import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import TextInputField from "@my-dld/components/Form/TextInputField";
import { StringUtil } from "@eres/core";
import { hideLoading, showLoading } from "@my-dld/utils/UIUtils";
import { SSOApi } from "@eres/ssoapi";
import { exToMessage } from "@eres/ssoapi/api";
import VerifyPopup from "@my-dld/components/VerifyPopup";
import { PasswordMeter, UserNameRequirements, validateNewPassword, validateRegExRequirement } from "../../../../MyDLD/MyProfile/ChangePassword";
import { SSORegContext } from "@my-dld/contexts/RegisterContext";

interface Props {
	onCreated: () => void;
}

interface State {
	formErrors: { [ k: string ]: string | undefined };
	userName: string;
	password: string;
	newPwdConfirm: string;
}

class UserId extends Component<Props, State> {
	static contextType = SSORegContext;
	context!: React.ContextType<typeof SSORegContext>;
	vp = React.createRef<VerifyPopup>();

	constructor( props: Props ) {
		super( props );
		this.state = {
			formErrors: {},
			userName: "",
			password: "",
			newPwdConfirm: "",
		};
	}

	isValid = () => {
		let isError = StringUtil.isEmptyStringOrNull( this.state.userName );
		isError = isError || StringUtil.isEmptyStringOrNull( this.state.password );
		isError = isError || StringUtil.isEmptyStringOrNull( this.state.newPwdConfirm );
		if ( !isError ) {
			const evs = Object.values( this.state.formErrors );
			isError = evs.filter( x => !StringUtil.isEmptyStringOrNull( x ) ).length !== 0;
		}
		return !isError;
	};

	render() {
		const formProps = {
			containerClassName: "form-group mb-4 field-style",
			inputClassName: "form-control",
			holder: this,
		};
		const { userName, password, newPwdConfirm, formErrors, } = this.state;
		const isValid = this.isValid();
		return (
			<>
				<div className="forgot-password-wrapper">
					<TextInputField
						{ ...formProps }
						placeHolder={ Strings.username_placeholder }
						id={ "userName" }
						error={ formErrors.userName }
						label={ Strings.user_name }
						required={ true }
						maxLength={ 250 }
						onValueChange={ ( value, extra ) => {
							this.validateUserName( value );
						} }
					>
						<UserIdMeter value={ userName }/>
					</TextInputField>
					<TextInputField
						{ ...formProps }
						placeHolder={ Strings.new_password }
						id={ "password" }
						error={ this.state.formErrors.password }
						label={ Strings.new_password }
						required={ true }
						maxLength={ 250 }
						inputProps={ {
							type: "password"
						} }
						onValueChange={ ( value, extra ) => {
							this.validatePwd( value );
						} }
						onValueUpdated={ ( value: string ) => {
							if ( !StringUtil.isEmptyStringOrNull( this.state.newPwdConfirm ) )
								this.validateConfirmPwd( this.state.newPwdConfirm );
						} }
					>
						<PasswordMeter value={ this.state.password }/>
					</TextInputField>
					<TextInputField
						{ ...formProps }
						placeHolder={ Strings.confirm_new_password }
						id={ "newPwdConfirm" }
						error={ this.state.formErrors.newPwdConfirm }
						label={ Strings.confirm_new_password }
						required={ true }
						maxLength={ 250 }
						inputProps={ {
							type: "password"
						} }
						onValueChange={ ( value, extra ) => {
							this.validateConfirmPwd( value );
						} }
					/>
					<div className="form-group">
						<button
							disabled={ !isValid }
							onClick={ this.submit }
							className="btn btn_1 btn_style1 btn-block">{ Strings.continue }</button>
					</div>
				</div>
			</>
		);
	}

	setError = ( key: string, error: string | undefined ) => {
		this.setState( s => {
			return {
				formErrors: {
					...s.formErrors,
					[ key ]: error,
				}
			};
		} );
	};
	validateUserName = ( value: string ) => {
		if ( StringUtil.isEmptyStringOrNull( value ) ) {
			this.setError( "userName", Strings.form_required_label );
		} else {
			try {
				validateUserId( value, false );
				this.setError( "userName", undefined );
			} catch ( e ) {
				this.setError( "userName", Strings.invalid_data );
			}

		}
	};
	validatePwd = ( value: string ) => {
		if ( StringUtil.isEmptyStringOrNull( value ) ) {
			this.setError( "password", Strings.form_required_label );
		} else {
			try {
				validateNewPassword( value );
				this.setError( "password", undefined );
			} catch ( e ) {
				this.setError( "password", Strings.password_req_fail );
			}
		}
	};
	validateConfirmPwd = ( value: string ) => {
		if ( value !== this.state.password ) {
			this.setError( "newPwdConfirm", Strings.passwords_doesnt_match );
		} else {
			this.setError( "newPwdConfirm", undefined );
		}
	};
	submit = () => {
		showLoading();
		SSOApi.register.create( this.context.mode, this.state.userName, this.state.password ).then( r => {
			hideLoading();
			this.props.onCreated();
		} )
		.catch( e => {
			hideLoading();
			exToMessage( e ).then( message => {
				let key = "userName";
				if ( message.src ) {
					key = message.src;
				}
				this.setError( key, message.error );
			} );
		} );
	};
}


export function UserIdMeter( props: { value: string } ) {
	if ( StringUtil.isEmptyStringOrNull( props.value ) ) {
		return null;
	}
	const r = UserNameRequirements();
	let normalMatches = r.filter( x => !x.isTopLevel );
	let topLevels = r.filter( x => x.isTopLevel );
	let isValid = false;
	try {
		isValid = validateUserId( props.value, true );
	} catch ( e ) {

	}
	return <div className={ "pwd-checker" }>
		<ul>
			{ normalMatches.map( ( value, index ) => {
				let isOky = true;
				try {
					validateRegExRequirement( value, props.value );
				} catch ( e ) {
					isOky = false;
				}
				return <li className={ isOky ? "valid-password" : "invalid-password" } key={ value.id }>
					<small>{ Strings[ value.message ] }</small>
				</li>;
			} ) }
			{ isValid && topLevels.map( ( value, index ) => {
				let isOky = true;
				try {
					validateRegExRequirement( value, props.value );
				} catch ( e ) {
					isOky = false;
				}
				if ( !isOky )
					return <li className={ isOky ? "valid-password" : "invalid-password" } key={ value.id }>
						<small>{ Strings[ value.message ] }</small>
					</li>;
				return null;
			} ) }
		</ul>
	</div>;
}

function validateUserId( userId: string, skipTop: boolean ) {
	let error: string[] = [];
	let reqs = UserNameRequirements( skipTop );
	for ( let req of reqs ) {
		try {
			validateRegExRequirement( req, userId );
		} catch ( e ) {
			error.push( e );
		}
	}
	if ( error.length === 0 ) return true;
	throw  error;
}

export default UserId;
